/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()

/* ==========================================================================
   Adega de Vidigueira — cabeçalho (27N)
   Guarda a altura do logótipo definida no tema (--adv-logo-h), para o
   cabeçalho poder encolher com transição ao descer (ver custom.css).
   ========================================================================== */
;(() => {
    const setLogoHeight = () => {
        document.querySelectorAll('#navbar-desktop .navbar-brand img, #navbar-mobile .navbar-brand img').forEach((img) => {
            const height = parseFloat(img.getAttribute('height'))
            if (height > 0) img.style.setProperty('--adv-logo-h', height + 'px')
        })
    }
    setLogoHeight()
    document.addEventListener('shopify:section:load', setLogoHeight)
})()

/* ==========================================================================
   Adega de Vidigueira — verificação de idade (27N)
   Em vez da data de nascimento, a pessoa confirma com um botão.
   O texto do botão principal é o «Button text» da secção; os textos de «não»
   estão aqui em baixo. O script do tema continua a gravar o cookie e a fechar.
   ========================================================================== */
;(() => {
    const NO_LABEL = 'Tenho menos de 18 anos'
    const DENIED_TITLE = 'Lamentamos, mas não pode entrar.'
    const DENIED_TEXT = 'O site da Adega de Vidigueira é exclusivo para maiores de 18 anos.'
    const BACK_LABEL = 'Voltar atrás'

    const setup = () => {
        const modal = document.getElementById('age-verification-modal')
        if (!modal || modal.dataset.advConfirm) return
        const body = modal.querySelector('.modal-body')
        const yes = body && body.querySelector('.btn')
        if (!yes) return
        modal.dataset.advConfirm = '1'

        // Sem campos de data, o intervalo do tema deixa de desativar o botão
        body.querySelectorAll('input').forEach((input) => {
            const row = input.closest('.row-cols-3')
            if (row) row.remove()
            else input.remove()
        })
        yes.disabled = false

        const no = document.createElement('button')
        no.type = 'button'
        no.className = 'btn w-100 adv-age-no'
        no.textContent = NO_LABEL
        yes.after(no)

        const denied = document.createElement('div')
        denied.className = 'adv-age-denied'
        denied.setAttribute('role', 'status')
        denied.hidden = true
        const title = document.createElement('p')
        title.className = 'adv-age-denied__title'
        title.textContent = DENIED_TITLE
        const text = document.createElement('p')
        text.textContent = DENIED_TEXT
        const back = document.createElement('button')
        back.type = 'button'
        back.className = 'adv-age-back'
        back.textContent = BACK_LABEL
        denied.append(title, text, back)
        no.after(denied)

        const toggle = (isDenied) => {
            modal.classList.toggle('adv-age-is-denied', isDenied)
            denied.hidden = !isDenied
            ;(isDenied ? back : yes).focus()
        }
        no.addEventListener('click', () => toggle(true))
        back.addEventListener('click', () => toggle(false))
    }

    setup()
    document.addEventListener('shopify:section:load', setup)
})()

/* ==========================================================================
   Adega de Vidigueira — entradas ao fazer scroll (27N)
   Os elementos que já estão no ecrã ao carregar ficam como estão (sem piscar).
   Os restantes entram com fade + subida quando chegam ao ecrã, em cascata.
   Não toca nas secções que já usam as animações nativas do tema.
   Desligado com "reduzir movimento" ou em browsers sem IntersectionObserver.
   ========================================================================== */
;(() => {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return
    if (!('IntersectionObserver' in window)) return
    // A página «Site em manutenção» (password) fica exatamente como está
    if (document.body && document.body.classList.contains('page-type-password')) return

    const docEl = document.documentElement
    docEl.classList.add('adv-motion')

    // [seletor, variante] — variante: '' (sobe), 'media' (imagem assenta), 'fade'
    const TARGETS = [
        ['main h2.title', ''],
        ['main h2.title + .description', ''],
        ['.cards-with-image .row > .col', ''],
        ['.promotion-grid-col', ''],
        ['.product-list > .product-item', ''],
        ['.article-item', ''],
        ['#footer-blocks > div', ''],
        ['.adv-a .adv-sec .adv-eyebrow', 'fade'],
        ['.adv-a .adv-sec h2', ''],
        ['.adv-a .adv-lead', ''],
        ['.adv-stat', ''],
        ['.adv-split__media img', 'media'],
        ['.adv-quote blockquote', ''],
        ['.adv-quote cite', 'fade'],
        ['.adv-tl > li', ''],
        ['.adv-feature', ''],
        ['.adv-grapes > div', ''],
        ['.adv-card', ''],
        ['.adv-award', ''],
        ['.adv-certs > span', 'fade'],
        ['.adv-cta h2', ''],
        ['.adv-cta p', ''],
        ['.adv-cta .adv-btns', '']
    ]
    const SKIP_INSIDE = '#sticky-atc, .offcanvas, .modal, .dropdown-menu, .shopify-section-group-header-group'
    const MANAGED = '[data-animate-class]:not([data-animate-class=""])'
    const STEP = 90
    const MAX_DELAY = 540

    const reveal = (el, delay) => {
        el.dataset.advShown = '1'
        el.style.setProperty('--adv-delay', delay + 'ms')
        requestAnimationFrame(() => el.classList.add('adv-in'))
        setTimeout(() => {
            el.classList.remove('adv-reveal', 'adv-reveal--media', 'adv-reveal--fade', 'adv-in')
            el.style.removeProperty('--adv-delay')
        }, delay + 1900)
    }

    // Carrosséis e filas com scroll horizontal: os vizinhos da mesma fila que estão
    // escondidos fora da área visível aparecem logo (senão entravam vazios ao deslizar)
    const revealRowMates = (el) => {
        const parent = el.parentElement
        if (!parent) return
        const top = el.getBoundingClientRect().top
        parent.querySelectorAll(':scope > .adv-reveal').forEach((sibling) => {
            if (sibling.dataset.advShown) return
            if (Math.abs(sibling.getBoundingClientRect().top - top) > 4) return
            observer.unobserve(sibling)
            reveal(sibling, 0)
        })
    }

    const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter(entry => entry.isIntersecting).map(entry => entry.target)
        visible.sort((a, b) => {
            const ra = a.getBoundingClientRect()
            const rb = b.getBoundingClientRect()
            return (ra.top - rb.top) || (ra.left - rb.left)
        })
        visible.forEach((el, index) => {
            observer.unobserve(el)
            reveal(el, Math.min(index * STEP, MAX_DELAY))
        })
        visible.forEach(revealRowMates)
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' })

    const scan = (scope) => {
        const viewportHeight = window.innerHeight || docEl.clientHeight
        TARGETS.forEach(([selector, variant]) => {
            scope.querySelectorAll(selector).forEach((el) => {
                if (el.dataset.advMotion) return
                el.dataset.advMotion = '1'
                if (el.closest(SKIP_INSIDE)) return
                if (el.closest(MANAGED) || el.querySelector(MANAGED)) return
                const rect = el.getBoundingClientRect()
                if (rect.top < viewportHeight && rect.bottom > 0) return
                el.classList.add('adv-reveal')
                if (variant) el.classList.add('adv-reveal--' + variant)
                observer.observe(el)
            })
        })
    }

    const start = () => scan(document)
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start)
    } else {
        start()
    }

    document.addEventListener('shopify:section:load', (event) => scan(event.target))
    window.addEventListener('updated.ecomify.collection', () => scan(document))
})()
